var React = require('react');

function IcChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"nonzero","d":"M.31 1.776L8.32 9.588c.38.37.995.37 1.375 0l7.996-7.828a.938.938 0 0 0 0-1.347.981.981 0 0 0-.688-.279.982.982 0 0 0-.688.28l-7.31 7.154L1.682.426A.988.988 0 0 0 .306.43.938.938 0 0 0 .31 1.776z"}));
}

IcChevronDown.defaultProps = {"width":"18","height":"10","viewBox":"0 0 18 10"};

module.exports = IcChevronDown;

IcChevronDown.default = IcChevronDown;
